import { useMemo, useState } from "react";
import { Drawer } from "@design-system/Drawer/Drawer";
import { PaginatedTransactionsTableContextProvider } from "@components/transactions/PaginatedTransactionsTableContextProvider";
import {
    TransactionSearchDrawerContent,
    TransactionSearchDrawerContentProps,
} from "./TransactionSearchDrawerContent";

interface TransactionSearchDrawerProps extends TransactionSearchDrawerContentProps {
    header: React.ReactNode;
}

export const TransactionSearchDrawer: React.FC<
    TransactionSearchDrawerProps
> = ({ header, ...props }) => {
    const [page, setPage] = useState(1);
    const [isOpen, setIsOpen] = useState(false);

    const shouldShowContent = useMemo(
        () => isOpen || props.open,
        [isOpen, props.open],
    );

    return (
        <Drawer
            open={props.open}
            onClose={props.onClose}
            direction="right"
            onAnimationEnd={setIsOpen}
            noPadding
            headerAddonLeft={header}
        >
            {shouldShowContent && (
                <>
                    <PaginatedTransactionsTableContextProvider
                        defaultView={props.view}
                        paginationMode={{ type: "pages", page, setPage }}
                        parentFilters={props.parentFilters}
                        cacheKey={props.cacheKey}
                    >
                        <TransactionSearchDrawerContent {...props} />
                    </PaginatedTransactionsTableContextProvider>
                </>
            )}
        </Drawer>
    );
};
